// @flow

import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import type { Theme } from '../../../types';
import TitleComponent from '../../title';
import { media } from '../../../helpers';

export const Header = styled<any, Theme>('header')`
  background-image: linear-gradient(
    -4deg,
    ${props => props.theme.news.articleHeaderBackgroundColor} 29.8%,
    ${props => props.theme.news.articleBackgroundColor} 30.2%
  );
  ${media.md(css`
    background-image: linear-gradient(
      -4deg,
      ${props => props.theme.news.articleHeaderBackgroundColor} 39.8%,
      ${props => props.theme.news.articleBackgroundColor} 40.2%
    );
  `)}
`;

export const Title = styled<typeof TitleComponent, Theme>(TitleComponent)`
  color: ${props => props.theme.news.articleTitleColor};
  padding: 0.25rem 0;
  font-size: 1.5rem;
  ${media.md(css`
    padding: 0.5rem 0;
    font-size: 1.75rem;
  `)}
  ${media.lg(css`
    padding: 1.25rem 0;
    font-size: 2.125rem;
  `)}
`;

export const Date = styled<any, Theme>('p')`
  color: ${props => props.theme.news.articleTitleColor};
  font-size: 1rem;
  ${media.md(css`
    font-size: 1.25rem;
  `)}
`;

export const StyledLink = styled<typeof Link, Theme>(Link)`
  text-decoration: none;
  color:  ${props => props.theme.news.articleTitleColor};
  &:hover {
    text-decoration: underline;
  }
  &::before {
    content: '‹ ';
  }
`;

type Props = {
  image: string,
};

export const NewsImage = styled<any, Theme>('div')`
  background: url(${(props: Props) => props.image});
  background-position: center;
  background-size: cover;
  flex-shrink: 0;
  height: 6.5rem;
  ${media.md(css`
    height: 16rem;
  `)}
  ${media.lg(css`
    height: 22rem;
  `)}
`;

export const ImageWrapper = styled<any, Theme>('div')`
  max-width: 60rem;
  margin: 0 auto;
  padding: 0 1rem;
`;
